import PropTypes from "prop-types";
import {useAssessment} from "traitify-widgets";
import DangerousHTML from "common/components/partials/dangerous-html";
import Loading from "common/components/partials/loading";
import Markdown from "common/components/partials/markdown";
import Divider from "common/components/partials/modal/divider";
import useI18n from "common/hooks/use-i18n";
import ash from "public/assets/images/survey/ash.jpg";

const instructionsKey = (deckID) => {
  switch(deckID) {
    case "career-deck":
    case "south-east-grocers":
      return "instructions_text";
    case "financial-risk-tolerance-2.0":
      return "financial_instructions_text";
    default:
      return "non_career_instructions_text";
  }
};

function AssessmentInstructions({animated}) {
  const assessment = useAssessment();
  const i18n = useI18n();
  if(!assessment) {
    return (
      <div className="text-center">
        <Loading />
      </div>
    );
  }

  if(assessment.instructions && assessment.instructions.instructional_text) {
    return <Markdown>{assessment.instructions.instructional_text}</Markdown>;
  }

  if(assessment.instructions && assessment.instructions.instructional_html) {
    return <DangerousHTML html={assessment.instructions.instructional_html} />;
  }

  if(animated) {
    return (
      <div className="markdown">
        <DangerousHTML html={i18n.t("assessment.animated_instruction_text_1")} />
        <ul>
          <div className="flex justify-center">
            <img className="h-[125px] w-auto rounded" src={ash} alt="Ash" />
            <div>
              <div className="border ml-2 mt-2 p-1 rounded-md">{i18n.t("assessment.ash_greeting")}</div>
            </div>
          </div>
        </ul>
        <DangerousHTML html={i18n.t("assessment.animated_instruction_text_2")} />
      </div>
    );
  }

  return <DangerousHTML html={i18n.t(`assessment.${instructionsKey(assessment.deck_id)}`)} />;
}

AssessmentInstructions.propTypes = {
  animated: PropTypes.bool.isRequired
};

function Instructions({allowSkip, animated, nextStep, requestAccommodation}) {
  const i18n = useI18n();

  return (
    <>
      <section>
        <AssessmentInstructions animated={animated} />
      </section>
      <Divider />
      <section className="flex gap-2 justify-between">
        {allowSkip ? (
          <button className="btn-outline-gray" onClick={requestAccommodation} title={i18n.t("survey.accommodation.request")} type="button">{i18n.t("survey.accommodation.request")}</button>
        ) : <div />}
        <button className="btn-theme" onClick={nextStep} title={i18n.t("assessment.close")} type="button">{i18n.t("assessment.lets_go")}</button>
      </section>
    </>
  );
}

Instructions.propTypes = {
  allowSkip: PropTypes.bool.isRequired,
  animated: PropTypes.bool.isRequired,
  nextStep: PropTypes.func.isRequired,
  requestAccommodation: PropTypes.func.isRequired
};

export default Instructions;
